import React from 'react';
import { Switch, Route, Redirect } from 'react-router';

import AuthOrApp from './authOrApp'
import Dashboard from '../dashboard/dashboard';
import UsuarioPerfil from '../usuarioPerfil/usuarioPerfil';
import Usuario from '../usuario/usuario';
import GrupoCliente from '../grupoCliente/grupoCliente';
import Cliente from '../cliente/cliente';
import Equipamento from '../equipamento/equipamento';
import Checklist from '../checklist/checklist';
import ModeloRelatorio from '../modeloRelatorio/modeloRelatorio';
import Relatorio from '../relatorio/relatorio';
import ChecklistResposta from '../checklistResposta/checklistResposta';
import MetaVisita from '../metaVisita/metaVisita';
import Departamento from '../departamento/departamento';
import CertificadoModelo from '../certificadoModelo/certificadoModelo';
import CertificadoEmissao from '../certificadoEmissao/certificadoEmissao';

export default props => (
	<div id='id-content-wrapper' className='content-wrapper' >
		<Switch>

			{props.usuarioCarregado.acesso_dashboard &&
			<Route exact path='/' component={Dashboard} />}

			{props.usuarioCarregado.acesso_cadastro_usuario &&
			<Route path='/usuarioPerfil' component={UsuarioPerfil} />}

			{props.usuarioCarregado.acesso_cadastro_usuario &&
			<Route path='/usuario' component={Usuario} />}

			{props.usuarioCarregado.acesso_cadastro_departamento &&
			<Route path='/departamento' component={Departamento} />}

			{props.usuarioCarregado.acesso_cadastro_cliente &&
			<Route path='/grupoCliente' component={GrupoCliente} />}

			{props.usuarioCarregado.acesso_cadastro_cliente &&
			<Route path='/cliente' component={Cliente} />}

			<Route path='/equipamento' component={Equipamento} />
			
			{props.usuarioCarregado.acesso_cadastro_checklist &&
			<Route path='/checklist' component={Checklist} />}

			{props.usuarioCarregado.acesso_cadastro_modelo_relatorio &&
			<Route path='/modeloRelatorio' component={ModeloRelatorio} />}

			{props.usuarioCarregado.acesso_relatorio &&
			<Route path='/relatorio' component={Relatorio} />}

			{(props.usuarioCarregado.acesso_checklist_resposta_admin || props.usuarioCarregado.acesso_checklist_resposta) &&
			<Route path='/checklistResposta' component={ChecklistResposta} />}

			<Route path='/metaVisita' component={MetaVisita} />

			{props.usuarioCarregado.acesso_cadastro_modelo_certificado &&
			<Route path='/certificadoModelo' component={CertificadoModelo} />}

			{props.usuarioCarregado.acesso_emitir_certificado &&
			<Route path='/certificadoEmissao' component={CertificadoEmissao} />}

			{props.usuarioCarregado.acesso_dashboard ? (
				<Redirect from='*' to='/' />
			) : ((props.usuarioCarregado.acesso_checklist_resposta_admin || props.usuarioCarregado.acesso_checklist_resposta) ? (
				<Redirect from='*' to='/checklistResposta' />
			) : (
				<Redirect from='*' to='/' />
			))}
		</Switch>
	</div>
);
